import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Modal, ModalBody } from "reactstrap";
import { GetQuoteButtonCss, ModalBodyWrapper, Header, ContentWrapper, } from "./GetQuoteModalStyled";
import { Form, Formik, Field } from "formik";
import UploadDummy from "web/assets/images/UploadDummy.png";
import * as Yup from "yup";
import Spinner from "web/components/Spinner";
import CloseIcon from "web/assets/images/CloseIcon.png";
import RadioButton from "web/components/form-elements/RadioButton";
import TextInput from "web/components/form-elements/TextInput";
import { checkIsZipCode } from "redux/actions/adminPtPlus/index";
import AlertModal from "web/components/AlertModal";
import NumberInput from "web/components/form-elements/NumberInput";
import PhoneNumber from "web/components/form-elements/PhoneNumber";
import TimePickerInput from "web/components/form-elements/TimePickerInput";
import DatePicker from "web/components/form-elements/DatePicker";
import Select from "web/components/form-elements/Select";
import UploadSpecification from "web/components/UploadSpecification";
import CheckboxInput from "web/components/form-elements/CheckboxInput";
import TextArea from "web/components/form-elements/TextArea";
import * as moment from "moment";
import { palletDetails } from "redux/actions/adminPtPlus";
import { uploadSpec, submitQuoteApi } from "redux/actions/postLoad";
import Captcha from "web/components/Captcha";
import ReCAPTCHA from "react-google-recaptcha";

function GetQuoteComponent(args) {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [alertModal, setAlertModal] = useState(false);
  const [alertModalContent, setAlertModalContent] = useState();
  const toggleAlertModal = () => setAlertModal(!alertModal);
  let history = useHistory();
  const dispatch = useDispatch();
  // const [captcha, setCaptcha] = useState("")
  const [captchaErrorMessage, setCaptchaErrorMessage] = useState("");
  const [captchaStatus, setCaptchaStatus] = useState(false);
  // const [captchaLoadCount, setCaptchaLoadCount] = useState(1)
  const [loaderVisible, setLoaderVisible] = useState(false);
  const [palletSpecificationDetails, setPalletSpecificationDetails] =
    useState();
  const conditionOptionsWood = [
    { value: "recycled", label: "Recycled" },
    { value: "newCondition", label: "New" },
    { value: "combo", label: "Combo" },
  ];
  const conditionOptionsPlastic = [
    { value: "recycled", label: "Recycled" },
    { value: "newCondition", label: "New" },
  ];
  const [conditionOptions, setConditionOptions] =
    useState(conditionOptionsWood);
  let newOrRecycledPalletList = [
    { label: "Block", value: "block" },
    { label: "Stringer", value: "stringer" },
    { label: "Euro Pallet", value: "euroPallet" },
    { label: "Crate", value: "crate" },
    { label: "Tray", value: "tray" },
    { label: "Other", value: "other" },
  ];
  let comboPalletList = [
    { label: "Stringer", value: "stringer" },
    { label: "Crate", value: "crate" },
    { label: "Custom", value: "custom" },
  ];
  const [palletTypeList, setPalletTypeList] = useState([]);
  const [moistureList, setmoistureList] = useState([]);
  const [sizeList, setSizeList] = useState([]);
  const [gradeList, setGradeList] = useState([]);
  const [defaultSpecFile, setDefaultSpecFile] = useState();
  const [uploadedSpecFileArr, setUploadedSpecFileArr] = useState();
  let fileArr = [];
  useEffect(() => {
    fetchPalletSpecDetails();
  }, []);

  const fetchPalletSpecDetails = async () => {
    let response = await dispatch(palletDetails());
    if (response.success) {
      setPalletSpecificationDetails(response.data);
    } else setPalletSpecificationDetails();
  };

  const INITIAL_VALUES = {
    contactName: "",
    email: "",
    phoneNumber: "",
    deliveryPickRadioValue: "Delivery",
    locationName: "",
    locationCity: "",
    locationState: "",
    locationZip: "",
    deliveryOrPickUpDateGetQuote: moment().format("MM/DD/YYYY"),
    AppointmentWindowFrom: "08:00",
    AppointmentWindowTo: "17:00",
    materialRadioValue: "wood",
    conditionRadioValue: "",
    palletType: "",
    moisture: "",
    size: "",
    grade: "",
    length: "",
    width: "",
    height: "",
    showHeatTreated: false,
    heatTreated: false,
    quantityGetQuote: "",
    quantityGetQuoteMaxValue: 540,
    equipmentChosenList: [],
    comments: "",
  };

  const VALIDATION_SCHEMA = Yup.object().shape({
    email: Yup.string()
      .trim()
      .email("Invalid Email")
      .required("Email is required."),
    contactName: Yup.string().trim().required("Contact Name is required."),
    locationName: Yup.string().trim().required("Location Name is required."),
    locationCity: Yup.string().trim().required("City is required."),
    locationZip: Yup.string().trim().required("Zip is required.").min(5, "Zip code is too short."),
    quantityGetQuote: Yup.string().trim().required("Quantity is required."),
    phoneNumber: Yup.string()
      .trim()
      .required("Phone Number is required.")
      .matches(/^\D*(\d\D*){10}\D*$/, "Phone Number is invalid.")
      .test("hasNonZero", "Phone Number is invalid.", function (value) {
        if (value) {
          const regex = /[1-9]/;
          return regex.test(value);
        }
        return true;
      }),
  });

  const deliveryPickRadioOptions = [
    { value: "Delivery", label: "Delivery" },
    { value: "Pickup", label: "Pickup" },
  ];
  const materialOptions = [
    { value: "wood", label: "Wood" },
    { value: "plastic", label: "Plastic" },
    { value: "other", label: "Other" },
  ];
  const equipmentOptions = ["Flatbed", "Enclosed Trailer", "Straight Truck"];

  const zipCodeHandler = async (value, setFieldValue) => {
    let response = "";
    if (value.length === 5) {
      response = await dispatch(checkIsZipCode(value, ""));
      if (response.success) {
        setFieldValue("locationCity", response?.data?.city);
        setFieldValue("locationZip", response?.data?.zipCode);
        setFieldValue("locationState", response?.data?.state);
      } else {
        if (response?.data?.error?.message === "Invalid Zip Code.") {
          setFieldValue("locationCity", "");
          setFieldValue("locationZip", "");
          setFieldValue("locationState", "");
          setAlertModalContent("Invalid Zip Code.");
          toggleAlertModal();
        } else if (
          response.error?.message === "Invalid Token" ||
          response.message === "Request failed with status code 401"
        ) {
          history.push("/sign-in");
          window.location.reload(false);
        } else {
          setAlertModalContent(
            response.error?.message ||
            response.message ||
            "Somethink went wrong, please try again after some time."
          );
          toggleAlertModal();
        }
      }
    } else {
      setFieldValue("locationCity", "");
      setFieldValue("locationState", "");
    }
  };

  const resetFieldValues = (setFieldValue, type) => {
    setGradeList([]);
    setFieldValue("grade", "");
    setFieldValue("length", "");
    setFieldValue("width", "");
    setFieldValue("height", "");
    setFieldValue("heatTreated", false);
    setFieldValue("showHeatTreated", false);
    setFieldValue("quantityGetQuoteMaxValue", 540);
    setDefaultSpecFile();
    setUploadedSpecFileArr();
    if (type === "all") {
      setPalletTypeList([]);
      setmoistureList([]);
      setSizeList([]);
      setFieldValue("palletType", "");
      setFieldValue("moisture", "");
      setFieldValue("size", "");
    } else if (type === "withoutPalletType") {
      setmoistureList([]);
      setSizeList([]);
      setFieldValue("moisture", "");
      setFieldValue("size", "");
    } else if (type === "withoutPalletTypeAndMoisture") {
      setSizeList([]);
      setFieldValue("size", "");
    } else if (type === "withoutPalletTypeMoistureAndSize") {
    }
  };

  const materialSelectFunction = (setFieldValue, materialValue) => {
    resetFieldValues(setFieldValue, "all");
    setFieldValue("conditionRadioValue", "");
    if (materialValue === "wood") setConditionOptions(conditionOptionsWood);
    else if (materialValue === "plastic")
      setConditionOptions(conditionOptionsPlastic);
    else if (materialValue === "other") setConditionOptions([]);
  };

  const conditionSelectFunction = (setFieldValue, conditionValue) => {
    resetFieldValues(setFieldValue, "all");
    if (conditionValue === "recycled" || conditionValue === "newCondition")
      setPalletTypeList(newOrRecycledPalletList);
    else if (conditionValue === "combo") setPalletTypeList(comboPalletList);
  };

  const palletTypeSelectionFunction = (
    formikValues,
    setFieldValue,
    palletTypeValue
  ) => {
    resetFieldValues(setFieldValue, "withoutPalletType");
    let tempSpecDetails =
      palletSpecificationDetails[formikValues.materialRadioValue]?.condition[
        formikValues.conditionRadioValue
      ][palletTypeValue.value]?.palletSpecificDetails;
    let tempMoistureList = tempSpecDetails
      ?.filter((val) => val.moisture && val.moisture !== "")
      .map((val) => val.moisture);
    let tempSizeList = tempSpecDetails
      ?.filter((val) => val.size && val.size !== "")
      .map((val) => val.size);
    if (tempMoistureList && tempMoistureList?.length > 0) {
      tempMoistureList = new Set(tempMoistureList);
      tempMoistureList = Array.from(tempMoistureList);
      tempMoistureList = tempMoistureList.map((data) => ({
        label: data,
        value: data,
      }));
      setmoistureList(tempMoistureList);
    } else if (tempSizeList && tempSizeList?.length > 0) {
      tempSizeList = new Set(tempSizeList);
      tempSizeList = Array.from(tempSizeList);
      tempSizeList = tempSizeList.map((data) => ({ label: data, value: data }));
      setSizeList(tempSizeList);
    } else if (palletTypeValue?.value === "custom") {
      tempSizeList = [{ label: "Custom", value: "Custom" }];
      setSizeList(tempSizeList);
    }
  };

  const moistureSelectionFunction = (
    formikValues,
    setFieldValue,
    moistureValue
  ) => {
    resetFieldValues(setFieldValue, "withoutPalletTypeAndMoisture");
    let tempSpecDetails =
      palletSpecificationDetails[formikValues.materialRadioValue]?.condition[
        formikValues.conditionRadioValue
      ][formikValues.palletType]?.palletSpecificDetails;
    let tempSizeList = tempSpecDetails
      ?.filter((val) => val.size && val.size !== "")
      .map((val) => val.size);
    if (tempSizeList && tempSizeList?.length > 0) {
      tempSizeList = new Set(tempSizeList);
      tempSizeList = Array.from(tempSizeList);
      tempSizeList = tempSizeList.map((data) => ({ label: data, value: data }));
      setSizeList(tempSizeList);
    }
  };

  const sizeSelectionFunction = (formikValues, setFieldValue, sizeValue) => {
    resetFieldValues(setFieldValue, "withoutPalletTypeMoistureAndSize");
    let tempSpecDetails =
      palletSpecificationDetails[formikValues.materialRadioValue]?.condition[
        formikValues.conditionRadioValue
      ][formikValues.palletType]?.palletSpecificDetails;
    let tempGradeList = tempSpecDetails
      ?.filter(
        (val) => val.grade && val.grade !== "" && val.size === sizeValue.value
      )
      .map((val) => val.grade);
    if (tempGradeList && tempGradeList?.length > 0) {
      tempGradeList = new Set(tempGradeList);
      tempGradeList = Array.from(tempGradeList);
      tempGradeList = tempGradeList.map((data) => ({
        label: data,
        value: data,
      }));
      setGradeList(tempGradeList);
    }
    let specFileArrayTemp = tempSpecDetails?.filter(
      (val) => val.size === sizeValue.value
    );
    if (specFileArrayTemp && specFileArrayTemp?.length > 0) {
      if (
        sizeValue.label !== "Custom" &&
        (!tempGradeList || tempGradeList?.length === 0)
      ) {
        let tempFilesObj = {
          label: specFileArrayTemp[0].file,
          value: specFileArrayTemp[0].file,
        };
        setDefaultSpecFile([tempFilesObj]);
        setUploadedSpecFileArr();
      }
      let maxQuantity = specFileArrayTemp[0]?.quantity;
      if (maxQuantity)
        setFieldValue("quantityGetQuoteMaxValue", parseInt(maxQuantity));
    }
    setFieldValue("showHeatTreated", true);
  };

  const gradeSelectionFunction = (formikValues, setFieldValue, gradeValue) => {
    setDefaultSpecFile();
    setUploadedSpecFileArr();
    let tempSpecDetails =
      palletSpecificationDetails[formikValues.materialRadioValue]?.condition[
        formikValues.conditionRadioValue
      ][formikValues.palletType]?.palletSpecificDetails;
    let specFileArrayTemp = tempSpecDetails?.filter(
      (val) => val.grade === gradeValue.value
    );
    if (specFileArrayTemp && specFileArrayTemp?.length > 0) {
      let tempFilesObj = {
        label: specFileArrayTemp[0].file,
        value: specFileArrayTemp[0].file,
      };
      setDefaultSpecFile([tempFilesObj]);
      setUploadedSpecFileArr();
    }
  };

  const downloadSpecFile = (fileValue) => {
    const fileUrl = process.env.REACT_APP_API_URL + "/order/image/" + fileValue;
    window.open(fileUrl);
  };

  // const getCaptchaStatus = (captchaStatusResponse) => {
  //     setCaptchaStatus(captchaStatusResponse)
  // }

  const recaptchaRef = useRef();
  const onRecaptchaChange = () => {
    const recaptchaValue = recaptchaRef.current.getValue();

    if (!recaptchaValue || recaptchaValue === "") {
      setCaptchaStatus(false); // Set captchaStatus to false when expired
    } else {
      setCaptchaStatus(true); // Set captchaStatus to true when reCAPTCHA is valid
    }
  };

  const submitRequestFunction = async (props) => {
    setLoaderVisible(true)
    let formikValues = props.values;
    if (!captchaStatus) {
      setCaptchaErrorMessage("Captcha not matched!");
      return;
    }
    const fromTimeValue = parseInt(
      formikValues.AppointmentWindowFrom?.replace(":", "")
    );
    const toTimeValue = parseInt(
      formikValues.AppointmentWindowTo?.replace(":", "")
    );
    if (toTimeValue < fromTimeValue) {
      setAlertModalContent("Appointment window time is invalid.");
      toggleAlertModal();
      return;
    }
    let specificationFileList;
    if (uploadedSpecFileArr) {
      let formData = new FormData();
      uploadedSpecFileArr.map((data) =>
        formData.append("uploadSpecification", data)
      );
      let response = await dispatch(uploadSpec(formData, ""));
      if (response.status === "SUCCESS") {
        specificationFileList = response.payload;
      } else {
        setLoaderVisible(false)
        return;
      }
    } else if (defaultSpecFile) {
      specificationFileList = [
        {
          orignalFileName: defaultSpecFile[0].value,
          fileName: defaultSpecFile[0].value,
        },
      ];
    }
    let transportEquipments = [];
    if (formikValues.equipmentChosenList.includes("Flatbed"))
      transportEquipments.push("FLAT_BED");
    if (formikValues.equipmentChosenList.includes("Enclosed Trailer"))
      transportEquipments.push("VAN");
    if (formikValues.equipmentChosenList.includes("Straight Truck"))
      transportEquipments.push("STRAIGHT");
    let data = {
      contactName: formikValues.contactName,
      email: formikValues.email,
      phoneNumber: formikValues.phoneNumber,
      locationName: formikValues.locationName,
      isPickup: formikValues.deliveryPickRadioValue === "Pickup" ? true : false,
      isDelivery:
        formikValues.deliveryPickRadioValue === "Delivery" ? true : false,
      city: formikValues.locationCity,
      state: formikValues.locationState,
      zip: formikValues.locationZip,
      requestDeliveryDate: moment(
        formikValues.deliveryOrPickUpDateGetQuote
      ).format("YYYY-MM-DD"),
      appointmetWindowBegin: formikValues.AppointmentWindowFrom + ":00",
      appointmetWindowEnd: formikValues.AppointmentWindowTo + ":00",
      material: formikValues.materialRadioValue,
      isCombo: formikValues.conditionRadioValue === "combo" ? true : false,
      isNew: formikValues.conditionRadioValue === "newCondition" ? true : false,
      isUsed: formikValues.conditionRadioValue === "recycled" ? true : false,
      commodity:
        formikValues.palletType !== "" ? formikValues.palletType : null,
      moistureContent:
        formikValues.moisture !== "" ? formikValues.moisture : null,
      sizeWiseGrad: formikValues.size !== "" ? formikValues.size : null,
      grade: formikValues.grade !== "" ? formikValues.grade : null,
      isHeatTreared: formikValues.heatTreated,
      commodityDim: {
        length: formikValues.length !== "" ? formikValues.length : null,
        width: formikValues.width !== "" ? formikValues.width : null,
        height: formikValues.height !== "" ? formikValues.height : null,
      },
      quantity: formikValues.quantityGetQuote,
      vehiclePreferences: transportEquipments,
      comment: formikValues.comments,
      specificationFile: specificationFileList,
      captcha: recaptchaRef.current.getValue(),
    };
    let submitApiResponse;
    submitApiResponse = await dispatch(submitQuoteApi(data));
    if (submitApiResponse?.status === "SUCCESS") {
      // setCaptcha('')
      resetFieldValues(props.setFieldValue, "all");
      setDefaultSpecFile();
      setUploadedSpecFileArr();
      setAlertModalContent(
        "Thank you for your quote request! Someone from our team will be in touch with you soon."
      );
      toggleAlertModal();
      toggle();
      setLoaderVisible(false)
    } else {
      setLoaderVisible(false)
      if (submitApiResponse?.response?.data?.error?.code === 403) {
        setAlertModalContent(submitApiResponse?.response?.data?.error?.message);
        toggleAlertModal();
      } else {
        setAlertModalContent(
          "Something went wrong, please try again in some time."
        );
        toggleAlertModal();
      }
    }
  };

  const setButtonEnableFunction = (props) => {
    let formikValues = props.values;
    let error = props.errors;
    let buttonEnable = false;

    if (Object.keys(error).length === 0) buttonEnable = false;
    else if (
      Object.keys(error).length === 1 &&
      error.uploadSpecificationImgLoad
    )
      buttonEnable = false;
    else return true;

    if (
      formikValues.contactName !== "" &&
      formikValues.email !== "" &&
      formikValues.phoneNumber !== "" &&
      formikValues.locationName !== "" &&
      formikValues.locationCity !== "" &&
      formikValues.locationZip !== "" &&
      formikValues.equipmentChosenList?.length !== 0 &&
      formikValues.quantityGetQuote !== "" &&
      formikValues.locationState !== "" &&
      formikValues.locationZip?.length > 4
    ) {
      buttonEnable = false;
    } else return true;

    if (formikValues.materialRadioValue === "other") {
      if (
        formikValues.length !== "" &&
        formikValues.width !== "" &&
        formikValues.height !== ""
      )
        buttonEnable = false;
      else return true;
    } else if (formikValues.materialRadioValue === "plastic") {
      if (
        formikValues.conditionRadioValue !== "" &&
        formikValues.length !== "" &&
        formikValues.width !== "" &&
        formikValues.height !== ""
      )
        buttonEnable = false;
      else return true;
    } else if (formikValues.materialRadioValue === "wood") {
      if (formikValues.size !== "") buttonEnable = false;
      if (formikValues.size === "Custom") {
        if (
          formikValues.length !== "" &&
          formikValues.width !== "" &&
          formikValues.height !== ""
        )
          buttonEnable = false;
        else return true;
      }
      if (gradeList?.length > 0) {
        if (formikValues.grade !== "") buttonEnable = false;
        else return true;
      }
    }

    // if (defaultSpecFile || uploadedSpecFileArr) buttonEnable = false
    // else return true

    if (captchaStatus) buttonEnable = false;
    else return true;
    return buttonEnable;
  };

  return (
    <>
      {/* <div className="web-view-menu"> */}
      <div>
        <GetQuoteButtonCss>
          <button onClick={toggle} className="Request_quote">REQUEST A QUOTE</button>
        </GetQuoteButtonCss>
      </div>
      {/* <div className="mobile-menu"> */}
      <div>
        <GetQuoteButtonCss>
          <button
            onClick={() => {
              history.push("/search-inventory");
            }}
          >
            SEARCH INVENTORY
          </button>
        </GetQuoteButtonCss>
      </div>

      <Modal
        isOpen={modal}
        toggle={toggle}
        {...args}
        size="lg"
        style={{ marginTop: "85px" }}
        className="getQuoteModal"
      >
        <ModalBodyWrapper>
          <ModalBody>
            <Formik
              initialValues={INITIAL_VALUES}
              validationSchema={VALIDATION_SCHEMA}
              onSubmit={(values) => { }}
            >
              {(props) => {
                const {
                  isValid,
                  dirty,
                  values,
                  errors,
                  touched,
                  setFieldValue,
                } = props;
                return (
                  <div>
                    <Form>
                      {loaderVisible && <Spinner />}
                      <Header>
                        <div className="text-header">
                          <h6>
                            {`Get Quote - `}
                            <span style={{ fontWeight: "100" }}>
                              Fill out the below form, or call 1-877-777-7495
                            </span>
                          </h6>
                        </div>
                        <img
                          src={CloseIcon}
                          className="closeIcon"
                          alt="close-icon"
                          onClick={() => {
                            toggle();
                            // setCaptcha('')
                            resetFieldValues(setFieldValue, "all");
                          }}
                        />
                      </Header>
                      <ContentWrapper>
                        <div className={`row mb-4`}>
                          <div className={`col-md-4`}>
                            <p>
                              Contact Name
                              <span className="mandatorystar">&#42;</span>
                            </p>
                            <TextInput
                              name="contactName"
                              inputType="textAndNumber"
                            />
                          </div>
                          <div className={`col-md-4`}>
                            <p>
                              Email Address
                              <span className="mandatorystar">&#42;</span>
                            </p>
                            <TextInput
                              name="email"
                              inputType=""
                              maxLength={100}
                            />
                          </div>
                          <div className={`col-md-4`}>
                            <p>
                              Phone Number
                              <span className="mandatorystar">&#42;</span>
                            </p>
                            <PhoneNumber
                              name="phoneNumber"
                              inputType="addressText"
                            />
                          </div>
                        </div>

                        {/* delivery or pick up selection options div */}
                        <div className={`row mt-3`}>
                          {deliveryPickRadioOptions.map((value, index) => (
                            <div className={`col-md-3`} key={index}>
                              <Field
                                component={RadioButton}
                                name="deliveryPickRadioValue"
                                id={value.value}
                                defaultValue={deliveryPickRadioOptions[0].value}
                                onSelect={(e) => { }}
                                label={value.label}
                              />
                            </div>
                          ))}
                        </div>
                        {/* Address details */}
                        <div>
                          <div className={`row`}>
                            <div className={`col-md-8`}>
                              <p>
                                {`${props.values?.deliveryPickRadioValue} Location Name`}
                                <span className="mandatorystar">&#42;</span>
                              </p>
                              <TextInput
                                name="locationName"
                                inputType="companyText"
                                showErrorMessages={true}
                              />
                            </div>
                          </div>
                        </div>
                        <div className={`row`}>
                          <div className={`col-md-4`}>
                            <p>
                              City<span className="mandatorystar">&#42;</span>
                            </p>
                            <TextInput
                              name="locationCity"
                              inputType="companyText"
                              showErrorMessages={true}
                            />
                          </div>
                          <div className={`col-md-4 locationState`}>
                            <p>
                              State<span className="mandatorystar">&#42;</span>
                            </p>
                            <TextInput
                              name="locationState"
                              inputType="companyText"
                              showErrorMessages={true}
                              disabled={true}
                            />
                          </div>
                          <div className={`col-md-4`}>
                            <p>
                              Zip<span className="mandatorystar">&#42;</span>
                            </p>
                            <NumberInput
                              name="locationZip"
                              showErrorMessages={true}
                              maxLength={5}
                              onChangeHandler={(value) => {
                                zipCodeHandler(value, setFieldValue);
                              }}
                            />
                          </div>
                        </div>
                        {/* Delivery/pick up date and time */}
                        <div>
                          <p
                            style={{
                              marginTop: "20px",
                              marginBottom: "0px",
                              fontWeight: "bold",
                            }}
                          >{`Requested ${props.values?.deliveryPickRadioValue} Date & Time`}</p>
                          <div className={`row`}>
                            <div className={`col-md-4 deliveryDateClass`}>
                              <p>
                                {props.values?.deliveryPickRadioValue} Date
                                <span className="mandatorystar">&#42;</span>
                              </p>
                              <DatePicker
                                name="deliveryOrPickUpDateGetQuote"
                                selectDateFlag={
                                  props.values?.deliveryOrPickUpDateGetQuote
                                }
                                callBackFun={(val) => { }}
                              />
                            </div>
                            <div className={`col-md-8`}>
                              <p>
                                Appointment Window
                                <span className="mandatorystar">&#42;</span>
                              </p>
                              <div className={`row`}>
                                <div className={`col-md-6 timmerPickerStyle`}>
                                  <TimePickerInput
                                    name="AppointmentWindowFrom"
                                    type="time"
                                    showErrorMessages={true}
                                    selectedValue={
                                      props.values?.AppointmentWindowFrom
                                    }
                                  />
                                </div>
                                <div className={`col-md-6 timmerPickerStyle`}>
                                  <TimePickerInput
                                    name="AppointmentWindowTo"
                                    type="time"
                                    showErrorMessages={true}
                                    selectedValue={
                                      props.values?.AppointmentWindowTo
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Pallet spec details */}
                        <div className="mt-3">
                          <p
                            style={{
                              marginTop: "20px",
                              marginBottom: "0px",
                              fontWeight: "bold",
                            }}
                          >
                            Pallet Details
                          </p>
                          <div className={`row`}>
                            <div className={`col-md-6`}>
                              <p style={{ fontWeight: "bold" }}>
                                Material
                                <span className="mandatorystar">&#42;</span>
                              </p>
                              <div className={`row`}>
                                {materialOptions.map((value, index) => (
                                  <div className={`col-md-4`} key={index}>
                                    <Field
                                      component={RadioButton}
                                      name="materialRadioValue"
                                      id={value.value}
                                      defaultValue={materialOptions[0].value}
                                      onSelect={(e) => {
                                        materialSelectFunction(
                                          setFieldValue,
                                          e.target.value
                                        );
                                      }}
                                      label={value.label}
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                            {conditionOptions?.length > 0 && (
                              <div className={`col-md-6`}>
                                <p style={{ fontWeight: "bold" }}>
                                  Condition
                                  <span className="mandatorystar">&#42;</span>
                                </p>
                                <div className={`row`}>
                                  {conditionOptions.map((value, index) => (
                                    <div className={`col-md-4`} key={index}>
                                      <Field
                                        component={RadioButton}
                                        name="conditionRadioValue"
                                        id={value.value}
                                        defaultValue={conditionOptions[0].value}
                                        onSelect={(e) =>
                                          conditionSelectFunction(
                                            setFieldValue,
                                            e.target.value
                                          )
                                        }
                                        label={value.label}
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>

                          {props.values?.materialRadioValue === "wood" && (
                            <>
                              <div className={`row mt-1 palletspec-style`}>
                                <div className={`col-md-4`}>
                                  <p style={{ fontWeight: "bold" }}>
                                    Pallet Type
                                    <span className="mandatorystar">&#42;</span>
                                  </p>
                                  <Select
                                    name="palletType"
                                    data={palletTypeList}
                                    disabled={palletTypeList.length === 0}
                                    placeholder="Select Pallet Type"
                                    onChangeHandler={(data) =>
                                      palletTypeSelectionFunction(
                                        props.values,
                                        setFieldValue,
                                        data
                                      )
                                    }
                                  />
                                </div>
                                {moistureList && moistureList?.length > 0 && (
                                  <div className={`col-md-4`}>
                                    <p style={{ fontWeight: "bold" }}>
                                      Moisture
                                      <span className="mandatorystar">
                                        &#42;
                                      </span>
                                    </p>
                                    <Select
                                      name="moisture"
                                      data={moistureList}
                                      disabled={moistureList.length === 0}
                                      placeholder="Select Mositure"
                                      onChangeHandler={(data) =>
                                        moistureSelectionFunction(
                                          props.values,
                                          setFieldValue,
                                          data
                                        )
                                      }
                                    />
                                  </div>
                                )}
                                <div className={`col-md-4`}>
                                  <p style={{ fontWeight: "bold" }}>
                                    Size
                                    <span className="mandatorystar">&#42;</span>
                                  </p>
                                  <Select
                                    name="size"
                                    data={sizeList}
                                    disabled={sizeList.length === 0}
                                    placeholder="Select Size"
                                    onChangeHandler={(data) =>
                                      sizeSelectionFunction(
                                        props.values,
                                        setFieldValue,
                                        data
                                      )
                                    }
                                  />
                                </div>
                                {gradeList && gradeList?.length > 0 && (
                                  <div className={`col-md-4`}>
                                    <p style={{ fontWeight: "bold" }}>
                                      Grade
                                      <span className="mandatorystar">
                                        &#42;
                                      </span>
                                    </p>
                                    <Select
                                      name="grade"
                                      data={gradeList}
                                      disabled={gradeList.length === 0}
                                      placeholder="Select Grade"
                                      onChangeHandler={(data) =>
                                        gradeSelectionFunction(
                                          props.values,
                                          setFieldValue,
                                          data
                                        )
                                      }
                                    />
                                  </div>
                                )}
                              </div>
                            </>
                          )}
                        </div>

                        {(props.values?.materialRadioValue === "plastic" ||
                          props.values?.materialRadioValue === "other" ||
                          props.values?.size === "Custom") && (
                            <div className={`row mt-1`}>
                              <div className={`col-md-4`}>
                                <p style={{ fontWeight: "bold" }}>
                                  {`Length (Inch)`}
                                  <span className="mandatorystar">&#42;</span>
                                </p>
                                <NumberInput
                                  name="length"
                                  showErrorMessages={true}
                                  maxLength={5}
                                  onChangeHandler={(value) => { }}
                                />
                              </div>
                              <div className={`col-md-4`}>
                                <p style={{ fontWeight: "bold" }}>
                                  {`Width (Inch)`}
                                  <span className="mandatorystar">&#42;</span>
                                </p>
                                <NumberInput
                                  name="width"
                                  showErrorMessages={true}
                                  maxLength={5}
                                  onChangeHandler={(value) => { }}
                                />
                              </div>
                              <div className={`col-md-4`}>
                                <p style={{ fontWeight: "bold" }}>
                                  {`Height (Inch)`}
                                  <span className="mandatorystar">&#42;</span>
                                </p>
                                <NumberInput
                                  name="height"
                                  showErrorMessages={true}
                                  maxLength={5}
                                  onChangeHandler={(value) => { }}
                                />
                              </div>
                            </div>
                          )}

                        {props.values?.showHeatTreated && (
                          <div className="row mt-1">
                            <div className={`col-md-4`}>
                              <CheckboxInput
                                name="heatTreated"
                                label="Heat Treated"
                                handleSelect={(val, label, flag) => { }}
                              />
                            </div>
                          </div>
                        )}

                        {defaultSpecFile &&
                          defaultSpecFile?.length > 0 &&
                          !uploadedSpecFileArr && (
                            <div
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                downloadSpecFile(defaultSpecFile[0]?.value)
                              }
                            >
                              <img src={UploadDummy} alt="upload Dummy" />
                              <span>{defaultSpecFile[0]?.label}</span>
                            </div>
                          )}
                        <div
                          style={{ marginTop: "20px", position: "relative" }}
                        >
                          <UploadSpecification
                            name="uploadSpecificationImgLoad"
                            props={props}
                            ProfileName=""
                            CompanyName=""
                            pageType=""
                            fileArr={fileArr}
                            imageLoadCallBack={(imageArr) => {
                              setUploadedSpecFileArr(imageArr);
                            }}
                            callBackFun={(imageArr) => {
                              setUploadedSpecFileArr(imageArr);
                            }}
                          />
                          {/* <span style={{ left: '160px', top: '6px', position: 'absolute' }} className='mandatorystar'>&#42;</span> */}
                        </div>
                        <div className="mt-3">
                          <p>
                            Quantity<span className="mandatorystar">&#42;</span>
                          </p>
                          <div className={`row`}>
                            <div className="col-md-4">
                              <NumberInput
                                name="quantityGetQuote"
                                showErrorMessages={true}
                                maxLength={5}
                                quantityLotsMaxValue={99999}
                                onChangeHandler={(value) => { }}
                              />
                            </div>
                          </div>
                        </div>
                        <div>
                          <p
                            style={{
                              marginTop: "20px",
                              marginBottom: "0px",
                              fontWeight: "bold",
                            }}
                          >
                            Equipment Requirements (Select all that apply)
                            <span className="mandatorystar">&#42;</span>
                          </p>
                          <div className={`row`}>
                            {equipmentOptions.map((data, i) => (
                              <div className="col-md-3">
                                <CheckboxInput
                                  name={data}
                                  label={data}
                                  // checked={true}
                                  handleSelect={(val, label, flag) => {
                                    let tempValue =
                                      props.values.equipmentChosenList;
                                    tempValue = tempValue.filter(
                                      (data) => data !== label
                                    );
                                    if (flag) tempValue.push(label);
                                    setFieldValue(
                                      "equipmentChosenList",
                                      tempValue
                                    );
                                  }}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="textAreaClass">
                          <p>Comment</p>
                          <TextArea
                            name="comments"
                            maxLength="200"
                            showErrorMessages={true}
                          />
                        </div>
                        <div className={`row mt-3`}>
                          <div className="col-md-9">
                            <ReCAPTCHA
                              ref={recaptchaRef}
                              sitekey={
                                process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY
                              }
                              onChange={onRecaptchaChange}
                            />
                          </div>
                        </div>
                        <div className="button-style">
                          <button
                            style={{
                              opacity: setButtonEnableFunction(props) ? 0.5 : 1,
                            }}
                            disabled={setButtonEnableFunction(props)}
                            onClick={() => submitRequestFunction(props)}
                          >
                            Submit Request
                          </button>
                        </div>
                      </ContentWrapper>
                    </Form>
                  </div>
                );
              }}
            </Formik>
          </ModalBody>
        </ModalBodyWrapper>
      </Modal>
      <AlertModal
        isOpen={alertModal}
        toggle={toggleAlertModal}
        title=""
        content={alertModalContent}
        link=""
      />
    </>
  );
}

export default GetQuoteComponent;
